import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=09ce4887&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style1 from "./Header.vue?vue&type=style&index=1&id=09ce4887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ce4887",
  null
  
)

export default component.exports